module.exports = __webpack_public_path__ + "static/img/lock.31de5fb2.svg";